import React from 'react'
import styled from '@emotion/styled';
import { ModalContainer,IconContainer,UIcon,SubmitContainer,StyleButton } from './CreateAdminUser';
import { useModal } from '../../../../hooks/Context';

const DisableClaim = (props:any) => {
  const {setShowModal} = useModal();
  const data = props.data;

  return (
    <ModalContainer style={{width:'400px',borderRadius:'8px'}}>
        <div>
          <div style={{borderRadius:'8px 8px 0 0'}}>
            <div>
              <IconContainer><UIcon /></IconContainer>
              <span>Disable Claim?</span>
            </div>
          </div>
          <Wrapper>
            <p>
             You are about to disable the claim <span style={{fontWeight:'bold'}}>{data.name}?</span>
            </p>
            <SubmitContainer>
            <span style={{cursor:"pointer"}} 
              onClick={()=> setShowModal(false)}>Cancel</span>
             <StyleButton style={{backgroundColor:'#DD5151',color:'#fff'}}>
              Yes, Disable
            </StyleButton> 
            
          </SubmitContainer>


          </Wrapper>
        </div>

    </ModalContainer>
  )
}

export default DisableClaim;

const Wrapper = styled.div`
  min-height:200px;
  display:flex;
  flex-direction:column;
  gap: 20px;
  padding:20px;
  border-radius:0 0 8px 8px;
  
`